<template lang="pug">
div
  HeroSection
  WhyErudio
  AprendizadoMao
  //- Partners
  SimpleManagement
  WantToTry
</template>

<script>
import HeroSection from '../components/enterprise/HeroSection'
import WhyErudio from '../components/enterprise/WhyErudio'
import AprendizadoMao from '../components/enterprise/AprendizadoMao'
import Partners from '../components/enterprise/Partners'
import SimpleManagement from '../components/enterprise/SimpleManagement'
import WantToTry from '../components/WantToTry'

export default {
  name: 'Enterprise',
  components: {
    HeroSection,
    WhyErudio,
    AprendizadoMao,
    Partners,
    SimpleManagement,
    WantToTry
  }
}
</script>

<style lang="sass"></style>
